import { render, staticRenderFns } from "./OutcomesHeader.vue?vue&type=template&id=5093b15a"
import script from "./OutcomesHeader.vue?vue&type=script&lang=js"
export * from "./OutcomesHeader.vue?vue&type=script&lang=js"
import style0 from "./OutcomesHeader.vue?vue&type=style&index=0&id=5093b15a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports